import { createClient, dedupExchange, cacheExchange, ssrExchange } from "urql";
import { publicConfig } from "@lululemon/ecom-core";
import { fetchExchange } from "./urql-custom-fetch-exchange";

// eslint-disable-next-line sonarjs/cognitive-complexity
export const getUrqlConfig = async ({ req }) => {
  const headers = {};

  if (req) {
    const accessToken = await req.app.locals.getSecret(
      "tf-contenteducation-akamai-token"
    );
    const cookie = !process.browser ? req?.header("cookie") : document.cookie;

    if (cookie && req?.cookies) {
      headers.cookies = req?.cookies;
      headers.cookie = cookie;
    }

    if (req.headers["x-forwarded-for"]) {
      headers["x-forwarded-for"] = req.header("x-forwarded-for");
    }
    headers.referer = req.headers.referer;
    // Setting this header disables the rule that akamai requires a locale cookie to be set.
    // Please do not remove as without this all requests from SEO crawler bots will fail when hitting the graphql endpoint
    headers.Accept = "application/json";
    headers["User-Agent"] = "lululemon/ecom-web-app";

    if (accessToken) {
      headers["x-lll-access-token"] = accessToken;
    }

    if (req.header("X-Akamai-Edgescape")) {
      headers["X-Akamai-Edgescape"] = req.header("X-Akamai-Edgescape");
    }

    if (req.header("True-Client-IP")) {
      headers["True-Client-IP"] = req.header("True-Client-IP");
    }

    if (global.correlationId) {
      headers["x-lll-ecom-correlation-id"] = global.correlationId;
    } else {
      headers["x-lll-ecom-correlation-id"] = "NO_CORRELATION_ID_FOUND";
    }
  }

  return {
    headers,
    toJSON() {
      return {};
    }, // Prevent user's cookies being cached in the SSR response
  };
};

const isServerSide = typeof window === "undefined";

const ssr = ssrExchange({
  isClient: !isServerSide,
  // eslint-disable-next-line no-underscore-dangle
  initialState: !isServerSide ? window.__URQL_DATA__ : undefined,
});

const urqlClientConfig = {
  url: `${publicConfig?.apiHost}${publicConfig?.apiHostBasePath}/graphql`,
  exchanges: [dedupExchange, ssr, cacheExchange, fetchExchange],
};

const client = createClient(urqlClientConfig);

let serverSideClient;
let lastKnownLocale;
let lastKnownSl;

export const createUrqlClient = (options) => {
  // if we're in the server
  if (isServerSide) {
    if (options && options.headers && options.headers.cookie) {
      const localeUpdated =
        lastKnownLocale &&
        lastKnownLocale !== options.headers.cookies.UsrLocale;
      const slUpdated =
        lastKnownSl && lastKnownSl !== options.headers.cookies.sl;

      if (serverSideClient && localeUpdated && slUpdated) {
        lastKnownLocale = options.headers.cookies?.UsrLocale;
        lastKnownSl = options.headers.cookies?.sl;

        serverSideClient = createClient({
          ...urqlClientConfig,
          fetchOptions: () => ({
            ...options,
            credentials: "include",
          }),
        });
      } else if (!serverSideClient) {
        lastKnownLocale = options.headers.cookies?.UsrLocale;
        lastKnownSl = options.headers.cookies?.sl;

        serverSideClient = createClient({
          ...urqlClientConfig,
          fetchOptions: () => ({
            ...options,
            credentials: "include",
          }),
        });
      }
    }

    return serverSideClient;
  }

  client.fetchOptions = () => ({
    ...options,
    credentials: "same-origin", // to support safari 10 and 11 sending Cookies: https://github.com/github/fetch#sending-cookies
  });

  return client;
};
